import React, { useEffect, useState } from "react";
import { api } from "../api";
import "./sales.css";

export default function SalesDashboard() {
  const [data, setData] = useState({});
  useEffect(() => {
    api
      .get("/sales/dashboard", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      })
      .then((r) => setData(r.data || {}));
  }, []);
  const money = (n) =>
    `₹ ${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
  const cards = [
    ["Quotation Value", money(data.quotationValue)],
    ["Proforma Value", money(data.proformaValue)],
    ["Invoice Raised", money(data.invoiceRaised)],
    ["Payment Received", money(data.paymentReceived)],
    ["Outstanding", money(data.outstanding)],
    ["Invoices", data.invoiceCount || 0],
  ];
  return (
    <div className="sales-page">
      <div className="sales-head">
        <div>
          <h2>Sales Dashboard</h2>
          <p>Finance sales overview.</p>
        </div>
      </div>
      <div className="sales-kpis">
        {cards.map(([k, v]) => (
          <div className="sales-card sales-kpi" key={k}>
            <span>{k}</span>
            <strong>{v}</strong>
          </div>
        ))}
      </div>
    </div>
  );
}
